import axios from 'axios';
import moment from 'moment';

import MitReservationService from '../../base/services/BaseMitReserveService.js';
import MitDateTimeService from '../../base/services/BaseMitReserveDateTimeService.js';

class MitImportReservationService {

    constructor() {
        this.serviceDateTime = new MitDateTimeService();
        this.defaultDateFormat = 'YYYY-MM-DD';
        this.defaultTimeFormat = 'hh:mm A';
        this.dateDisplayFormat1 = 'ddd MMM DD YYYY';
        this.dateDisplayFormat2 = 'MMM DD YYYY';
        this.dateTimeDisplayFormat1 = 'ddd MMM DD YYYY hh:mm A';
        this.dateTimeDisplayFormat2 = 'MMM DD YYYY hh:mm A';

        this.defaultDuration = 60;//in minutes
    }

    loadFromFile(filePath){
        return new Promise ((resolve, reject) => {
            var reader = new FileReader();
            reader.onload = (event) => {
                //returns file contents as string
                return resolve(event.target.result)
            }
            reader.onerror = (evt) => {
                return reject('Error loading file:', filePath)
            }
            reader.readAsText(filePath);
        });
    }

    parseTSV(tsv){
        let y;
        let data = tsv.split('\n');
        for (let i=0; i<data.length; i++) {
            y = data[i].split('\t');
            data[i] = y;
        }

        let series = [];
        let model;
        for(let z = 1; z < data.length-1; z++){
            //loop header and grab properties
            model = {};
            for(let i = 0; i < data[0].length; i++){
                model[data[0][i]] = data[z][i];
            }
            
            series.push(model);

        }
        return series;
    }

    createReservationModels(data){
        let reservations = [];
        let model;
        let recurringData;
        let duplicates = [];

        let duplicateDetectionDic = {};

        for (let i=0; i<data.length; i++) {

            model = MitReservationService.create();
            model.data = {
                externalId:data[i].meeting_id,
                externalSeriesId: (data[i].meeting_series_id === "NULL") ? null : data[i].meeting_series_id
            }
            model.owner = data[i].creator.toLowerCase();
            model.startDateTime = moment.utc(data[i].start_time, 'YYYY-MM-DD HH:mm:ss').local();
            model.endDateTime = moment.utc(data[i].end_time, 'YYYY-MM-DD HH:mm:ss').local();
            model.name = data[i].name;
            model.mitId = data[i].reserved_id;
            
            model.setupDescription = data[i].setup_instructions;
            if(model.setupDescription && model.setupDescription.length > 1){
                model.setupState = 'requested';
            }
            
            if(data[i].schedule_yaml){
                recurringData = this.getRecurringYamlData(data[i].schedule_yaml, data[i].meeting_id);
                model.recurring.repeatChoice = 'weekly'
                model.recurring.weeklyInterval = recurringData.weeklyInterval;
                model.recurring.days = recurringData.days;
                model.recurring.repeatsUntilDate = moment.utc(data[i].end_date).local().endOf('day');
            }
            model.mitId = data[i].reserved_id;

            MitReservationService.addDisplayDates(model);

            //before pushing check if this is a duplicate, not sure if name is necessary
            let uniqueKey = model.mitId+model.startDateTime.format("YYYY-MM-DD hh:mm A")+model.endDateTime.format("YYYY-MM-DD hh:mm A")+model.name;
            if(duplicateDetectionDic.hasOwnProperty(uniqueKey)){
                //This is a duplicate
                duplicates.push(model)
            }
            else{
                //Not a duplicate, so add it to the dict as an entry we have processed.
                duplicateDetectionDic[uniqueKey] = true;
                reservations.push(model);
            }

        }
        console.log('DETECTED DUPLICATES', duplicates);
        return reservations;
    }

    getRecurringYamlData(scheduleYaml, meetingId){
        let findStrings = {
            interval:':interval:',
            day:':day:\\n',
            weeklyRule:'::WeeklyRule',
            dailyRule:'::DailyRule'
        }

        let result = {
            weeklyInterval:null,
            days:{
                monday:false,
                tuesday:false,
                wednesday:false,
                thursday:false,
                friday:false,
                saturday:false,
                sunday:false
            }
        };

        let interval;
        try {
            let startIndex = scheduleYaml.indexOf(findStrings.interval) + findStrings.interval.length;
            let endIndex = scheduleYaml.indexOf('\\n',startIndex);
            interval = scheduleYaml.substring(startIndex, endIndex);
            interval = parseInt(interval);
            result.weeklyInterval = interval;

            

            if(scheduleYaml.indexOf(findStrings.dailyRule) > -1){
                //from calendar
                result.days = {
                    monday:true,
                    tuesday:true,
                    wednesday:true,
                    thursday:true,
                    friday:true,
                    saturday:true,
                    sunday:true
                }
            }
            else{
                //from calendar database, only one weekly day is supported
                startIndex = scheduleYaml.indexOf(findStrings.day) + findStrings.day.length;
                endIndex = scheduleYaml.indexOf('\\n',startIndex);
                let day = scheduleYaml.substring(startIndex, endIndex);
                day = day.replace('-','');
                day = parseInt(day);

                switch(day){
                    case 0:
                        result.days.sunday = true;
                        break;
                    case 1:
                        result.days.monday = true;
                        break;
                    case 2:
                        result.days.tuesday = true;
                        break;
                    case 3:
                        result.days.wednesday = true;
                        break;
                    case 4:
                        result.days.thursday = true;
                        break;
                    case 5:
                        result.days.friday = true;
                        break;
                    case 6:
                        result.days.saturday = true;
                        break;
                    default:
                        console.log('ERROR finding DAY for meeting ID: '+meetingId);
                        break;

                }

            }

        }
        catch(error){
            console.log('error - getRecurringYamlData with meeting ID: '+meetingId, error);
        }
        
        return result;
    }

    buildAPIModels(reservations){
        let result = {
            reservations:[],//single instances
            recurring:[], //part of series of reservations and their children
            all:[] //basically just for displaying any preview of them all
        }
        let uniqueRecurring = {};
        let recurringParent;

        for (let i=0; i<reservations.length; i++) {

            //if this is a series or recurring reservation or child of it
            if(reservations[i].data.externalSeriesId){
                if(uniqueRecurring.hasOwnProperty(reservations[i].data.externalSeriesId)){
                    reservations[i].recurring.repeatChoice = null;//turn off recurring for this since its a child
                    uniqueRecurring[reservations[i].data.externalSeriesId].children.push(reservations[i]);
                }
                else{
                    //make the parent out of the first one in the list.
                    recurringParent = MitReservationService.copy(reservations[i]);
                    //this is a series so its ID is the series ID
                    recurringParent.data.externalId = recurringParent.data.externalSeriesId;
                    //Add to the dict and list
                    uniqueRecurring[reservations[i].data.externalSeriesId] = recurringParent;
                    result.recurring.push(recurringParent);
                    result.all.push(recurringParent);
                    recurringParent.children = [];
                    recurringParent.children.push(reservations[i]);
                }
            }
            //process a single reservation
            else{
                reservations[i].recurring = null;//turn off recurring for this since its a single instance
                result.reservations.push(reservations[i]);
                result.all.push(reservations[i]);
            }
            
        }

        return result;
    }

    parseCSVRecurring(csv){

    }

    parseCSVReservations(csv){

    }

    deleteImportedReservations(){
        return new Promise ((resolve, reject) => {
            axios.delete('/api/v1/admin/reservations/import/delete')
                .then((response) => {
                    return resolve(response.data);
                })
                .catch((error) => {
                    console.log('ERROR:', error);
                    return reject(error.response.data);
                });
        })
    }

    saveRecurring(recurringReservations){
        return new Promise ((resolve, reject) => {
            //convert to api model
            let apiRecurring, child;
            let apiModelList = [];
            for(let x = 0; x < recurringReservations.length; x++ ){
                apiRecurring = MitReservationService.convertUIToAPI(recurringReservations[x]);
                apiRecurring.children = [];
                apiRecurring.owner = recurringReservations[x].owner;
                for(let i = 0; i < recurringReservations[x].children.length; i++ ){
                    child = MitReservationService.convertUIToAPI(recurringReservations[x].children[i]);
                    child.owner = recurringReservations[x].children[i].owner;
                    apiRecurring.children.push(child);
                }
                apiModelList.push(apiRecurring);
            }
            
            axios.post('/api/v1/admin/reservations/import/recurring', apiModelList)
                .then((response) => {
                    return resolve(response.data);
                })
                .catch((error) => {
                    console.log('ERROR:', error);
                    return reject(error.response.data);
                });
        })
    }

    saveReservations(reservations){
        return new Promise ((resolve, reject) => {
            let apiReservation;
            let apiModelList = [];
            for(let x = 0; x < reservations.length; x++ ){
                apiReservation = MitReservationService.convertUIToAPI(reservations[x]);
                apiReservation.owner = reservations[x].owner;
                apiModelList.push(apiReservation);
            }

            axios.post('/api/v1/admin/reservations/import/reservations', apiModelList)
                .then((response) => {
                    return resolve(response.data);
                })
                .catch((error) => {
                    console.log('ERROR:', error);
                    return reject(error.response.data);
                });
        })
    }


}
export default new MitImportReservationService();
